import { ReactElement } from "react";
import { Stack } from "@altimateai/lego";
import { default as CrownLogo } from "@/assets/icons/crown.svg?react";
import { Button, Tooltip } from "@altimateai/lego";
import { useIntercom } from "react-use-intercom";

export function PremiumBanner({ variant }: { variant: "small" | "large" }): ReactElement {
  const { show } = useIntercom();

  return (
    <Stack align="center" className={variant === "small" ? "al-text-xs al-h-8" : "al-text-md"}>
      <Tooltip title="Click to contact us to get access">
        <Button
          variant="ghost"
          size={variant === "small" ? "sm" : "default"}
          className={`!al-rounded-full al-bg-blue-100`}
          onClick={show}
        >
          <CrownLogo
            className={`al-text-blue-500 ${
              variant !== "large" ? "al-h-4 al-w-4" : "al-h-6 al-w-6"
            }`}
          />
          <span className="al-text-blue-500">View Now</span>
        </Button>
      </Tooltip>
    </Stack>
  );
}
